var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotwear4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.8453 70.8802C74.1113 70.5925 61.2291 76.4602 57.5567 75.1946C55.3762 74.4324 54.1712 58.5551 52.378 58.5551L47.644 76L26.1977 70.2042C24.5766 67.8313 33.3991 35.8754 35.4218 31L69.4634 31.2301C71.6726 35.5733 80.2511 69.3989 78.8453 70.8802Z",
    fill: "#AE2100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotwear4);
export default __webpack_public_path__ + "static/media/notwear4.0c18ac242883c623b9588ae8b754ee11.svg";
export { ForwardRef as ReactComponent };